export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14291.34b0bd43.jpg";